import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PageShell } from './PageShell.js';
export function BspPageShell({ bspProvider, ...shellProps }) {
    const shell = _jsx(PageShell, { ...shellProps });
    return _jsx(_Fragment, { children: bspProvider ? bspProvider(shell) : shell });
}
export default BspPageShell;
